import React from 'react';

function Contact({ onBack, onNavigate }) {
  return (
    <div style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto' }}>
      <button
        onClick={onBack}
        style={{
          marginBottom: '20px',
          padding: '10px 20px',
          background: '#1890ff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '1em',
        }}
      >
        ← 返回主页
      </button>

      <h1 style={{ fontSize: '2.5em', marginBottom: '30px', color: '#333' }}>联系我们</h1>
      
      <div style={{ lineHeight: '1.8', fontSize: '1.1em', color: '#555' }}>
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.8em', color: '#1890ff', marginBottom: '15px' }}>我们很乐意听到您的声音</h2>
          <p>
            无论您有任何问题、建议或反馈，都欢迎通过以下方式联系我们。
            您的每一条意见都将帮助我们改进产品，为用户提供更好的学习体验。
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.8em', color: '#1890ff', marginBottom: '15px' }}>联系方式</h2>
          <div style={{ background: '#f5f5f5', padding: '20px', borderRadius: '8px' }}>
            <p style={{ marginBottom: '15px' }}>
              <strong>电子邮箱：</strong> 
              <a href="mailto:vincentyip@126.com" style={{ color: '#1890ff', textDecoration: 'none' }}>
                vincentyip@126.com
              </a>
            </p>
            {/* <p style={{ marginBottom: '15px' }}>
              <strong>微信公众号：</strong> 削词侠XIAOCIXIA
            </p>
            <p style={{ marginBottom: '15px' }}>
              <strong>工作时间：</strong> 周一至周五 9:00-18:00 (北京时间)
            </p> */}
          </div>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.8em', color: '#1890ff', marginBottom: '15px' }}>常见问题</h2>
          <p>
            联系我们之前，建议先查看
            <button
              onClick={() => onNavigate('faq')}
              style={{ background: 'none', border: 'none', color: '#1890ff', cursor: 'pointer', fontSize: '1em', padding: '0', margin: '0 4px', textDecoration: 'underline' }}
            >
              常见问题解答
            </button>
            ，或许能更快找到答案。
          </p>
        </section>

        <section>
          <h2 style={{ fontSize: '1.8em', color: '#1890ff', marginBottom: '15px' }}>商务合作</h2>
          <p>
            如果您对商务合作感兴趣，请发送邮件至：
            <a href="mailto:vincentyip@126.com" style={{ color: '#1890ff', textDecoration: 'none', marginLeft: '5px' }}>
              vincentyip@126.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}

export default Contact;